(function () {
    'use strict';

    function WZServiceItemController($scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;

        loadPage();


        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader.addPart('supplierPanel');
            translatePartialLoader = translate.refresh();

            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }


        $scope.$watch('ServiceItemform.$valid', function (isValid) {
            $ctrl.isFormValid(isValid);
        })
    }

    var WZServiceItem = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms/service-item/wizard-form.service-item.html',
        controller: WZServiceItemController,
        bindings:
            {
                serviceItem: '=?',
                isFormValid: '=?',
                companyActivityType: '=?',
                servant: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfServiceItem', WZServiceItem)

    WZServiceItemController.$inject = ['$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

